import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { createPageViewData } from "../../utils/tealium";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import { DePrizes } from "./DePrizes";
import { EnPrizes } from "./EnPrizes";
import { EsPrizes } from "./EsPrizes";
import { FrPrizes } from "./FrPrizes";
import { GrPrizes } from "./GrPrizes";
import { PtPrizes } from "./PtPrizes";

const getPrizesTranslated = (lang: string) => {
  const prizesTranslated: { [key: string]: React.ReactElement } = {
    en: <EnPrizes />,
    fr: <FrPrizes />,
    es: <EsPrizes />,
    de: <DePrizes />,
    pt: <PtPrizes />,
    el: <GrPrizes />,
  };
  return prizesTranslated[lang];
};

const Prizes = () => {
  const { t } = useTranslation("prizes");
  useEffect(() => {
    createPageViewData("prizes");
  }, []);

  return (
    <Wrapper>
      <Main>
        <Copy>
          <h2>{t("prizes.pageTitle", "NBA Fantasy Prizes")}</h2>
          {getPrizesTranslated(i18n.language)}
        </Copy>
      </Main>
    </Wrapper>
  );
};
export default Prizes;
